
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import ThemeSwitcher from '../ThemeSwitcher';
import { Separator } from '../ui/separator';

interface MobileMenuProps {
  isOpen: boolean;
  activeSection: string;
  isHomePage: boolean;
  handleNavLinkClick: (e: React.MouseEvent<HTMLAnchorElement>, href: string) => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, activeSection, isHomePage, handleNavLinkClick }) => {
  const location = useLocation();

  if (!isOpen) return null;

  const primaryNavLinks = [
    { name: 'About', href: '#about' },
    { name: 'Experience', href: '#experience' },
    { name: 'Writing', href: isHomePage ? '#blog' : '/blog' },
  ];

  const secondaryNavLinks = [
    { name: 'Skills', href: '#skills' },
    { name: 'Personal', href: '#personal' },
    { name: 'Video', href: '#video-resume' },
    { name: 'Certifications', href: '#certifications' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <div className="md:hidden bg-background/95 backdrop-blur-sm shadow-lg animate-in fade-in slide-in-from-top">
      <nav className="flex flex-col px-4 py-4">
        <div className="flex justify-end mb-2">
          <ThemeSwitcher />
        </div>

        {primaryNavLinks.map((link) => {
          const isActive = link.name === 'Writing' && location.pathname.startsWith('/blog')
            ? true
            : activeSection === link.href.substring(1);

          return (
            <Link
              key={link.name}
              to={link.href.startsWith('#') && !isHomePage ? '/' + link.href : link.href}
              className={`py-3 border-b border-border/50 text-sm font-medium transition-colors tracking-wide font-mono interactive-link ${isActive
                  ? 'text-primary'
                  : 'text-muted-foreground hover:text-primary/80'
                }`}
              onClick={(e) => handleNavLinkClick(e, link.href)}
            >
              {link.name}
            </Link>
          );
        })}

        <div className="py-2">
          <p className="text-xs text-muted-foreground py-2">More sections</p>
          {secondaryNavLinks.map((link) => {
            const isActive = activeSection === link.href.substring(1);

            return (
              <Link
                key={link.name}
                to={link.href.startsWith('#') && !isHomePage ? '/' + link.href : link.href}
                className={`py-2 block text-sm font-medium transition-colors tracking-wide font-mono interactive-link ${isActive
                    ? 'text-primary'
                    : 'text-muted-foreground hover:text-primary/80'
                  }`}
                onClick={(e) => handleNavLinkClick(e, link.href)}
              >
                {link.name}
              </Link>
            );
          })}
        </div>

        <Button asChild className="mt-4 hover-ripple">
          <a
            href="https://drive.google.com/file/d/1Jn88Lw-iZnhX-qiaAqKx-14F_M1uYHWI/view?usp=drive_link"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium"
          >
            Resume
          </a>
        </Button>
      </nav>
    </div>
  );
};

export default MobileMenu;
